import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SocialReactionEmoji from './surveyTypes/SocialReactionEmoji';
import SocialReactionLike from './surveyTypes/SocialReactionLike';
import PulseRangeFaces from './surveyTypes/PulseRangeFaces';
import PulseRangeNumbers from './surveyTypes/PulseRangeNumbers';
import PulseRangeStars from './surveyTypes/PulseRangeStars';
import PulseBinaryThumbsUpAndDown from './surveyTypes/PulseBinaryThumbsUpAndDown';
import PulseBinaryYesAndNo from './surveyTypes/PulseBinaryYesAndNo';
import PulseBinaryCheckboxConfirm from './surveyTypes/PulseBinaryCheckboxConfirm';
import Enps from './surveyTypes/Enps';
import rules from '../../../../../../../../constants/businessRules/businessRules';
import { elementContentType } from '../../../../../../../../types';
import * as canvasErrorActions from '../../../../../../../../actions/elementErrors';

class SurveyElement extends PureComponent {
    state = {
        hasError: false,
        contentValues: {
            iconSize: 32,
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            paddingBottom: 0,
        },
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { blockIndex, columnIdx, elmIdx, content, type, dispatch } = nextProps;
        const { iconSize, iconImages, paddingTop, paddingRight, paddingLeft, paddingBottom, surveyTitle } = content;
        const contentValues = { iconSize, iconImages, paddingTop, paddingRight, paddingLeft, paddingBottom, surveyTitle };
        const hasError = surveyTitle === 'Survey Title' || surveyTitle === '';
        const newState = { ...prevState, hasError, contentValues };

        if (hasError) {
            dispatch(canvasErrorActions.addErroneousElement({ blockIndex, columnIdx, elmIdx, type, error: 'missing survey title' }));
        }

        if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
            return { ...newState };
        }

        return { ...prevState };
    }

    componentWillUnmount() {
        const { blockIndex, elmIdx, dispatch } = this.props;
        dispatch(canvasErrorActions.deleteErroneousElement({ blockIndex, elmIdx }));
    }


    render() {
        const { contentValues, hasError } = this.state;
        const { content } = this.props;
        const surveyType = content.type;
        switch (surveyType) {
            case rules.surveyTypes.SOCIAL_REACTION_EMOJI:
                return (<SocialReactionEmoji contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.SOCIAL_REACTION_LIKE:
                return (<SocialReactionLike contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_RANGE_FACES:
                return (<PulseRangeFaces contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_RANGE_NUMBERS:
                return (<PulseRangeNumbers contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_RANGE_STARS:
                return (<PulseRangeStars contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_BINARY_THUMBS_UP_AND_DOWN:
                return (<PulseBinaryThumbsUpAndDown contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_BINARY_YES_AND_NO:
                return (<PulseBinaryYesAndNo contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.PULSE_BINARY_CHECKBOX_CONFIRM:
                return (<PulseBinaryCheckboxConfirm contentValues={contentValues} hasError={hasError} />);
            case rules.surveyTypes.ENPS:
                return (<Enps contentValues={contentValues} hasError={hasError} />);
            default:
                return null;
        }
    }
}


SurveyElement.propTypes = {
    dispatch: PropTypes.func.isRequired,
    content: elementContentType.isRequired,
    blockIndex: PropTypes.string.isRequired,
    elmIdx: PropTypes.string.isRequired,
    columnIdx: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

export default connect()(SurveyElement);
